import { render, staticRenderFns } from "./app-install.vue?vue&type=template&id=0d483c3e&scoped=true&"
import script from "./app-install.vue?vue&type=script&lang=js&"
export * from "./app-install.vue?vue&type=script&lang=js&"
import style0 from "./app-install.vue?vue&type=style&index=0&id=0d483c3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d483c3e",
  null
  
)

export default component.exports